import { AccountCircle } from '@mui/icons-material';
import { Avatar, Typography, TypographyProps } from '@mui/material';
import { Box } from '@mui/system';

import { abbreviateId, isAddressFromPegaxyTeam } from '../../utils/humanizer';

type UserTagsProps = {
  publicAddress?: string;
  typographyProps?: TypographyProps;
};

export const UserTag = ({ publicAddress, typographyProps }: UserTagsProps): JSX.Element => {
  if (!publicAddress) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
        <AccountCircle sx={{ mr: 0.5 }} />
        <Typography variant="body2" {...typographyProps}>
          Hidden User
        </Typography>
      </Box>
    );
  } else if (isAddressFromPegaxyTeam(publicAddress)) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
        <Avatar
          sx={{ height: 20, width: 20, mr: 1 }}
          src="https://pegaxy.io/wp-content/uploads/2021/09/cropped-logo-seo.jpg"
        />
        <Typography variant="body2" color="text.secondary" {...typographyProps}>
          Pegaxy Team
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
      <AccountCircle sx={{ mr: 0.5 }} />
      <Typography variant="body2" {...typographyProps}>
        {abbreviateId(publicAddress)}{' '}
      </Typography>
    </Box>
  );
};
